import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'pipeDomSanitizer'
})
export class PipeDomSanitizer implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDomSanitizer.ts